var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Logo_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3504 1.24863C22.3825 1.5206 23.199 2.32143 23.4763 3.33379C23.9846 5.1772 24 9 24 9C24 9 24 12.8379 23.4917 14.6662C23.2144 15.6786 22.3979 16.4794 21.3659 16.7514C19.5019 17.25 12 17.25 12 17.25C12 17.25 4.49807 17.25 2.63415 16.7514C1.60205 16.4794 0.785623 15.6786 0.508344 14.6662C0 12.8228 0 9 0 9C0 9 0 5.1772 0.49294 3.3489C0.770218 2.33654 1.58665 1.53571 2.61874 1.26374C4.48267 0.76511 11.9846 0.75 11.9846 0.75C11.9846 0.75 19.4865 0.75 21.3504 1.24863ZM15.8203 9L9.59692 12.5357V5.46429L15.8203 9Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYou);
export default __webpack_public_path__ + "static/media/you.802a4d8fef565afe159862d896f54de5.svg";
export { ForwardRef as ReactComponent };